import React from "react"
import { Link } from "gatsby"

import Layout from "../../components/layout"
import Image from "../../components/image"
import SEO from "../../components/seo"

export default ({ pageContext, location }) => {
  return (
    <>
      <SEO location={location} title="Page2"/>
      <Layout pageContext={pageContext}>
        <h1>Page2</h1>
        <Image name="p2.jpg" />
        <Link to="/page2/page3">Page3</Link>
      </Layout>
    </>
  );
};
